import { ReversalHistoryKey } from '../../TModules';

export const translations = {
  [ReversalHistoryKey]: {
    Title: 'Cronologia annullamenti',
    Administrator: 'Amministratore',
    Source: 'Origine',
    SourceTransactionReversal: 'Storno transazione',
    SourceBulkAction: 'Azione in blocco',
    StatusSuccess: 'Riuscito',
    StatusFailed: 'Fallito',
    ExportCsv: 'Esporta CSV',
    Campaign: 'Campagna',
    TicketCode: 'Codice biglietto',
    Customer: 'Cliente',
    Reason: 'Motivo',
    Outcome: 'Esito',
    FailureMessage: 'Messaggio di errore',
    ReversedOn: 'Annullato il',
    System: 'Sistema',
    FilterCampaign: 'Filtra per campagna',
    FilterAdministrator: 'Filtra per amministratore',
    FilterSource: 'Filtra per origine',
    FilterOutcome: 'Filtra per esito',
    ExportQueued: 'Esportazione in coda — invieremo il CSV a {{email}}'
  }
};
